// routes
// utils
import moment from 'moment';
import { onboarding_server, private_server } from '../utils/axios';

// ----------------------------------------------------------------------

/**
 * The function decodes a JSON Web Token (JWT) and returns the payload as a JSON object.
 * @param token - The JWT (JSON Web Token) that needs to be decoded.
 * @returns a decoded JSON payload from a JWT token.
 */
function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

/**
 * The function checks if a given access token is valid by decoding it and comparing its expiration
 * time with the current time.
 * @param accessToken - The access token is a string that represents the authorization granted to a
 * user to access a particular resource or perform a specific action. In this case, the function is
 * checking whether the access token is valid or not.
 * @returns a boolean value. It returns `false` if the `accessToken` parameter is falsy (null,
 * undefined, false, 0, "", NaN), or if the token has expired (the expiration time `decoded.exp` is
 * less than the current time `currentTime`). Otherwise, it returns `true`.
 */
export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return (decoded.exp > currentTime) || true;
};

// ----------------------------------------------------------------------

/**
 * The function checks if a token has expired and removes it from local storage if it has.
 * @param exp - The expiration time of a token in seconds since the Unix epoch.
 */
export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = moment().unix() * 1000
  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  const timeLeft = exp * 1000 - currentTime;
  //clearTimeout(expiredTimer);

  if(timeLeft < 0){
    localStorage.removeItem('accessToken');
    delete onboarding_server.defaults.headers.common.Authorization;
  }

  /*expiredTimer = setTimeout(() => {
    alert('Token expired');

    //localStorage.removeItem('accessToken');
//
    //window.location.href = '/login';
  }, timeLeft);*/
};

// ----------------------------------------------------------------------

/**
 * The function sets the access token in local storage and adds it to the headers for requests to a
 * specific server, and also handles token expiration.
 * @param accessToken - The access token is a string that represents the authorization granted to a
 * user to access a particular resource or perform a specific action. In this code snippet, the access
 * token is used to set the authorization header for requests made to a server. It is also stored in
 * the browser's local storage for future use
 */
export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    //private_server.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    onboarding_server.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const data = jwtDecode(accessToken); // ~3 days by minimals server
    //console.log(data)
    tokenExpired(data?.exp);
  } else {
    localStorage.removeItem('accessToken');
    delete onboarding_server.defaults.headers.common.Authorization;
  }
};
